import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../../store/config';
import { GroupType, GroupTypeEditPayload } from './groupType.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/groupTypes');

export const getGroupTypeList = actionCreator.async<{}, GroupType[]>('GET_GROUP_TYPES_LIST');
export const addGroupType = actionCreator.async<FormName, GroupType>('ADD_GROUP_TYPE');
export const deleteGroupType = actionCreator.async<{ id: string; formName: FormName }, void>('DELETE_GROUP_TYPE');
export const editGroupType = actionCreator.async<GroupTypeEditPayload, void>('EDIT_GROUP_TYPE');
